module.exports = __webpack_public_path__ + "static/img/Bachelor_010243.0d652b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010243.jpg
// module id = 127
// module chunks = 0